import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../sections/Hero";
import About from "../sections/About";
import WorkArchive, { Marquee } from "../sections/WorkArchive";
import Collective from "../sections/Collective";
import Manifesto from "../sections/Manifesto";
import Contact from "../sections/Contact";

const Home = () => {
  const { state } = useLocation();

  // Scroll to a section when navigated from another route
  useEffect(() => {
    if (state?.scrollTo) {
      const t = setTimeout(() => {
        const el = document.getElementById(state.scrollTo);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 250);
      return () => clearTimeout(t);
    }
  }, [state]);

  return (
    <div data-testid="home-page">
      <Hero />
      <About />
      <Marquee />
      <WorkArchive />
      <Collective />
      <Manifesto />
      <Contact />
    </div>
  );
};

export default Home;
